<template>
  <section>
    <figure
      v-if="imageable.length === 1"
      @click="$emit('open')"
      class="c-carousel"
    >
      <ResponsiveImage
        v-if="imageable[0].image_id"
        :id="imageable[0].image_id"
        :css="'c-carousel__image c-carousel__image--center'"
      />
      <ImageCaption
        v-if="imageable[0].image_id"
        :id="imageable[0].image_id"
        :css="'c-carousel__caption'"
      />
    </figure>
    <carousel
      v-else-if="imageable.length > 1"
      :residence_id="residence_id"
    />
  </section>
</template>

<script>
// Data models
import Imageable from '@/models/Imageable';

// Components
import Carousel from '@/components/Carousel.vue';
import ResponsiveImage from '@/components/ResponsiveImage.vue';
import ImageCaption from '@/components/ImageCaption.vue';

export default {
  name: 'Illustration',
  components: {
    Carousel,
    ResponsiveImage,
    ImageCaption,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    residence_id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    imageable() {
      return Imageable.query()
        .where('imageable_id', this.residence_id)
        .get();
    },
  },
};
</script>
